const lbaMultiSelect = angular.module('app.lbaMultiSelect', []);

lbaMultiSelect.controller('lbaMultiSelectCtrl', require('./lbaMultiSelectCtrl'));
lbaMultiSelect.directive('lbaMultiSelect', require('./lbaMultiSelectDir'));

export default lbaMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lbaMultiSelect/index.js